import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'flex-privacy-policy-privacy-content',
  standalone: true,
  templateUrl: './privacy-content.component.html',
  styleUrl: './privacy-content.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyContentComponent {
  @Input() html = '';
}
